import FinancialRep from 'models/financial_rep.model';
import BaseNMComCollection from 'collections/base.nmcom.collection';
import FieldAdapter from 'adapters/field.adapter.js';

export default class FinancialReps extends BaseNMComCollection {
  static model = FinancialRep;

  static adapter = FieldAdapter;

    matchingRequestId;

    promiseCreate(options = {}) {
      throw new Error('create is not allowed on financial reps');
    }

    promiseSave(options = {}) {
      throw new Error('save is not allowed on financial reps');
    }

    promiseDestroy(options = {}) {
      throw new Error('destroy is not allowed on financial reps');
    }

    promiseFetchMatches(params = {}, options = {}) {
      options['endpoint'] = 'financial_reps/matches.json';
      options['params'] = params;
      return this.promiseFetch(options);
    }

    receiveResponse(response, options) {
      const headers = response.headers || {};
      this.matchingRequestId = headers['nmx-matching-request-id'];
    }
}
